import * as pdfjs from 'pdfjs-dist'
import 'pdfjs-dist/build/pdf.worker.entry'

// Recorte em pontos (página Letter) dos gráficos Self, Conceito do Self e Síntese na página 1 do PDF da PI
const Recorte = { x: 40.5, y: 172.5, largura: 531.75, altura: 459.75 }
const LarguraPaginaLetter = 612
const Escala = 4

export async function ObterImagemPerfilPI(url: string): Promise<string | undefined> {
  try {
    const pdf = await pdfjs.getDocument(url).promise
    const page = await pdf.getPage(1)

    if (Math.abs(page.view[2] - LarguraPaginaLetter) > 2) return undefined

    const viewport = page.getViewport({ scale: Escala })
    const pagina = document.createElement('canvas')
    pagina.width = viewport.width
    pagina.height = viewport.height
    const contextoPagina = pagina.getContext('2d')
    if (!contextoPagina) return undefined

    await page.render({ canvasContext: contextoPagina, viewport }).promise

    const recorte = document.createElement('canvas')
    recorte.width = Recorte.largura * Escala
    recorte.height = Recorte.altura * Escala
    const contextoRecorte = recorte.getContext('2d')
    if (!contextoRecorte) return undefined

    contextoRecorte.fillStyle = '#ffffff'
    contextoRecorte.fillRect(0, 0, recorte.width, recorte.height)
    contextoRecorte.drawImage(
      pagina,
      Recorte.x * Escala, Recorte.y * Escala, recorte.width, recorte.height,
      0, 0, recorte.width, recorte.height
    )

    return recorte.toDataURL('image/png')
  } catch {
    return undefined
  }
}
